var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from 'react';
import { faChartNetwork } from '@fortawesome/pro-light-svg-icons/faChartNetwork';
import { faPlusSquare } from '@fortawesome/pro-light-svg-icons/faPlusSquare';
import { faCodeBranch } from '@fortawesome/pro-regular-svg-icons/faCodeBranch';
import { faDiamondTurnRight } from '@fortawesome/pro-regular-svg-icons/faDiamondTurnRight';
import { faLayerGroup } from '@fortawesome/pro-regular-svg-icons/faLayerGroup';
import orderBy from 'lodash/orderBy';
import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import { ModernAccordion } from '../../../components/Accordion/ModernAccordion';
import { BlockWidget, CardWidget, GridWidget, TileWidget } from '../Widgets';
import { NAVIGATION_TYPES, PATCH_TYPES } from '../SbGlobal/constants';
import { Icon, Wrapper } from '../SbGlobal/styles';
import { selectCareerSource } from '../../../store/structureBuilderCarrer/selectors';
import { checkIsAddPatchModalFromFloatingMenu, selectAddPatchModalState, selectAddPatchModalTabIndex, selectHelpModalOpen, selectModalPosition, } from '../../../store/structureBuilderUI/selectors';
import { defaultPatchSchema } from './schema';
import { HeaderContainer, ModalContent, NonAccordionWrapper, PatchContainer, SectionTitle, Tab, TabContainer, TabText, customModalStyles, } from './styles';
import { buildDefaultName } from '../PatchWidget/helpers';
import { Searchbar } from '../Searchbar';
import { changeAddPatchModalState, fireEvent, setHelpModalStatus, setTabIndex, updateModalPosition, } from 'store/structureBuilderUI/reducer';
import { clearCareerSource } from 'store/structureBuilderCarrer/reducer';
import { useCloseOnRouteChange } from 'utils/hooks/closeOnRouteChange';
/**
 * Register Modal to the app root
 */
Modal.setAppElement('#app');
export var AddPatchModal = function (_a) {
    var views = _a.views, customLogics = _a.customLogics, integrations = _a.integrations, patchFilter = _a.patchFilter, onClose = _a.onClose, onSave = _a.onSave, onCreateNewView = _a.onCreateNewView, onCreateNewCustomLogic = _a.onCreateNewCustomLogic;
    var dispatch = useDispatch();
    var _b = useState([]), patchSchema = _b[0], setPatchSchema = _b[1];
    var _c = useState(''), searchValue = _c[0], setSearchValue = _c[1];
    var isModalOpen = useSelector(selectAddPatchModalState);
    var tabIndex = useSelector(selectAddPatchModalTabIndex);
    var isHelpModalOpen = useSelector(selectHelpModalOpen);
    var modalPosition = useSelector(selectModalPosition);
    var careerSource = useSelector(selectCareerSource);
    var isAddPatchModalFromFloatingMenu = useSelector(checkIsAddPatchModalFromFloatingMenu);
    var actions = useMemo(function () { return ({
        closeModal: function () {
            dispatch(changeAddPatchModalState(false));
            dispatch(updateModalPosition(null));
        },
        clearCareerSource: function () {
            dispatch(clearCareerSource());
        },
        resetLinkEvent: function () {
            dispatch(fireEvent(''));
        },
    }); }, [dispatch]);
    var dispatchTabIndex = useCallback(function (index) {
        dispatch(setTabIndex(index));
    }, [dispatch]);
    var helpModalOpen = useCallback(function (status) {
        dispatch(setHelpModalStatus(status));
    }, [dispatch]);
    var createViewsSchema = function (views) {
        var viewsHolder = {
            label: 'Views',
            type: 'view',
            options: [],
        };
        var listHolder = {
            label: 'Lists',
            type: 'list',
            options: [],
        };
        viewsHolder.options.push({
            label: 'New View',
            value: 'new:view',
        });
        listHolder.options.push({
            label: 'New List',
            value: 'new:list',
        });
        if (views === null || views === void 0 ? void 0 : views.length) {
            views.forEach(function (view) {
                if (view.type === 'view') {
                    viewsHolder.options.push({
                        label: view.name,
                        value: view.id,
                        type: 'view',
                    });
                }
                else {
                    listHolder.options.push({
                        label: view.name,
                        value: view.id,
                        type: 'list',
                    });
                }
            });
        }
        return [
            {
                label: 'Views',
                type: 'view',
                category: 0,
                display: 'card',
                noAccordion: true,
                options: [viewsHolder],
            },
            {
                label: 'Lists',
                type: 'view',
                category: 0,
                display: 'card',
                noAccordion: true,
                options: [listHolder],
            },
        ];
    };
    var createCustomLogicSchema = function (customLogics) {
        var _a;
        var customLogicHolder = {
            label: 'Custom Logic',
            type: 'custom_logic',
            options: [],
        };
        customLogicHolder.options.push({
            label: 'New Custom Logic',
            value: 'new:custom_logic',
            icon: faPlusSquare,
        });
        if (customLogics === null || customLogics === void 0 ? void 0 : customLogics.length) {
            (_a = orderBy(customLogics, 'updated_at', 'desc')) === null || _a === void 0 ? void 0 : _a.forEach(function (logic) {
                var _a, _b;
                customLogicHolder.options.push({
                    label: logic.name,
                    value: logic === null || logic === void 0 ? void 0 : logic.id,
                    icon: (_b = (_a = logic === null || logic === void 0 ? void 0 : logic.meta) === null || _a === void 0 ? void 0 : _a.icon) !== null && _b !== void 0 ? _b : faChartNetwork,
                    type: 'logic',
                    groupId: logic === null || logic === void 0 ? void 0 : logic.id,
                });
            });
        }
        return {
            label: 'Custom Logic',
            type: 'logic',
            category: 1,
            display: 'tile',
            noAccordion: true,
            options: [customLogicHolder],
        };
    };
    var createMethodOptions = function (key, integrationId, methods) { return ({
        label: "Integration - ".concat(key),
        type: 'integration',
        options: methods.map(function (method) { return ({
            label: method.name,
            groupId: integrationId,
            value: "".concat(method.id),
        }); }),
    }); };
    var filterOptions = useCallback(function (group) {
        var _a, _b, _c;
        return (_c = (_b = ((_a = group === null || group === void 0 ? void 0 : group.options) !== null && _a !== void 0 ? _a : [])) === null || _b === void 0 ? void 0 : _b.filter(function (option) {
            var _a, _b, _c, _d;
            return ((_b = (_a = option === null || option === void 0 ? void 0 : option.value) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(searchValue.toLowerCase())) ||
                ((_d = (_c = option === null || option === void 0 ? void 0 : option.label) === null || _c === void 0 ? void 0 : _c.toLowerCase()) === null || _d === void 0 ? void 0 : _d.includes(searchValue.toLowerCase()));
        })) !== null && _c !== void 0 ? _c : [];
    }, [searchValue]);
    var filterGroups = useCallback(function (section) {
        var _a, _b;
        return (_b = ((_a = section === null || section === void 0 ? void 0 : section.options) !== null && _a !== void 0 ? _a : [])) === null || _b === void 0 ? void 0 : _b.map(function (group) {
            var _a;
            return (__assign(__assign({}, group), { options: filterOptions(group), optionCount: (_a = filterOptions(group)) === null || _a === void 0 ? void 0 : _a.length }));
        });
    }, [filterOptions]);
    // Combine static and dynamic schema together
    var buildPatchSchema = useCallback(function () {
        var _a, _b, _c, _d;
        // View schema will be there by default, since it contains create new view/list option
        var patchSchema = (_a = createViewsSchema(views)) !== null && _a !== void 0 ? _a : [];
        // Custom logic schema will be there by default, since it contains create new custom logic option
        patchSchema.push(createCustomLogicSchema(customLogics));
        if (defaultPatchSchema === null || defaultPatchSchema === void 0 ? void 0 : defaultPatchSchema.length) {
            patchSchema.push.apply(patchSchema, defaultPatchSchema);
        }
        if (integrations === null || integrations === void 0 ? void 0 : integrations.length) {
            var methodOptions_1 = [];
            integrations.forEach(function (integration) {
                var _a;
                if ((_a = integration.methods) === null || _a === void 0 ? void 0 : _a.length) {
                    var methods = createMethodOptions(integration.name, integration.id, integration.methods);
                    methodOptions_1.push(methods);
                }
            });
            patchSchema.push({
                label: 'Integrations',
                type: 'logic',
                category: 1,
                display: 'block',
                options: (integrations === null || integrations === void 0 ? void 0 : integrations.length) ? methodOptions_1 : [],
            });
        }
        if (!searchValue) {
            patchSchema = patchSchema.filter(function (section) { return section.category === tabIndex; });
        }
        if (searchValue) {
            return (_c = (_b = patchSchema
                .map(function (section) {
                var _a;
                return (__assign(__assign({}, section), { options: filterGroups(section), optionCount: (_a = filterGroups(section)) === null || _a === void 0 ? void 0 : _a.reduce(function (acc, group) {
                        var _a;
                        if (acc === void 0) { acc = 0; }
                        acc += (_a = group.options) === null || _a === void 0 ? void 0 : _a.length;
                        return acc;
                    }, 0) }));
            })) === null || _b === void 0 ? void 0 : _b.filter(function (section) {
                var _a, _b, _c;
                return (_c = (_b = ((_a = section === null || section === void 0 ? void 0 : section.options) !== null && _a !== void 0 ? _a : [])) === null || _b === void 0 ? void 0 : _b.filter(function (group) { var _a, _b; return (_b = ((_a = group === null || group === void 0 ? void 0 : group.options) !== null && _a !== void 0 ? _a : [])) === null || _b === void 0 ? void 0 : _b.length; })) !== null && _c !== void 0 ? _c : [];
            })) === null || _c === void 0 ? void 0 : _c.filter(function (section) {
                return (patchFilter === null || patchFilter === void 0 ? void 0 : patchFilter.length)
                    ? __spreadArray(__spreadArray([], patchFilter, true), ['route'], false).includes(section.type)
                    : true;
            });
        }
        if (patchFilter === null || patchFilter === void 0 ? void 0 : patchFilter.length) {
            return ((_d = patchSchema === null || patchSchema === void 0 ? void 0 : patchSchema.filter(function (section) {
                return __spreadArray(__spreadArray([], patchFilter, true), ['route'], false).includes(section.type);
            })) !== null && _d !== void 0 ? _d : []);
        }
        return patchSchema;
    }, [
        filterGroups,
        integrations,
        patchFilter,
        searchValue,
        tabIndex,
        views,
        customLogics,
    ]);
    var handleOnCloseModal = useCallback(function () {
        if (!isHelpModalOpen) {
            actions.closeModal();
            setSearchValue('');
            actions.resetLinkEvent();
            actions.clearCareerSource();
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }
    }, [actions, isHelpModalOpen, onClose]);
    // This page never unmounts on navigation, so this portal-rendered modal
    // stays open above whatever page the user navigates to unless we close it
    // explicitly on route change.
    useCloseOnRouteChange(isModalOpen, handleOnCloseModal);
    var handleOnSearchChange = function (value) {
        setSearchValue(value);
    };
    var onSubmit = useCallback(function (type, option) {
        var _a;
        var _b;
        var newPatchPattern = new RegExp(/^new:((view)|(list)|(custom_logic))$/);
        var newEdge = {
            from_arg: careerSource === null || careerSource === void 0 ? void 0 : careerSource.sourcePort,
            from_patch: careerSource === null || careerSource === void 0 ? void 0 : careerSource.sourceNode,
            to_arg: undefined,
            to_patch: undefined,
        };
        var position = careerSource.position
            ? careerSource.position
            : undefined;
        // When creating new view
        if (newPatchPattern.test(option.value)) {
            if (option.value === 'new:view') {
                onCreateNewView(__assign({ name: buildDefaultName(views === null || views === void 0 ? void 0 : views.map(function (view) { var _a; return (_a = view === null || view === void 0 ? void 0 : view.name) !== null && _a !== void 0 ? _a : ''; }), 'New View'), type: 'view' }, position), newEdge);
            }
            // When creating new list
            if (option.value === 'new:list') {
                onCreateNewView(__assign({ name: buildDefaultName(views === null || views === void 0 ? void 0 : views.map(function (view) { var _a; return (_a = view === null || view === void 0 ? void 0 : view.name) !== null && _a !== void 0 ? _a : ''; }), 'New List View'), type: 'list' }, position), newEdge);
            }
            if (option.value === 'new:custom_logic') {
                onCreateNewCustomLogic(__assign({ name: buildDefaultName(customLogics === null || customLogics === void 0 ? void 0 : customLogics.map(function (customLogic) { var _a; return (_a = customLogic === null || customLogic === void 0 ? void 0 : customLogic.name) !== null && _a !== void 0 ? _a : ''; }), 'New Custom Logic'), type: 'logic' }, position), newEdge);
            }
        }
        else {
            var patchToSave = void 0, selectedView = void 0;
            switch (type) {
                case 'integration':
                    if (option.groupId && option.value) {
                        patchToSave = {
                            name: option.label,
                            type: 'logic',
                            logic: 'integration',
                            settings: {
                                integrationId: option.groupId,
                                methodId: option.value,
                                tunnelThrough: false,
                            },
                        };
                        onSave(__assign(__assign({}, patchToSave), position), newEdge);
                    }
                    break;
                case 'list':
                    patchToSave = {
                        name: option.label,
                        type: 'list',
                        list: 'from_view',
                        settings: {
                            layout: 'list',
                            loadable: 'loading',
                            padding: {
                                paddingTop: 0,
                                paddingLeft: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                            },
                        },
                    };
                    selectedView = views.find(function (item) { return item.id === option.value; });
                    if (selectedView && selectedView.type === 'list') {
                        patchToSave.type = selectedView.type;
                        patchToSave.list = 'from_view';
                        patchToSave.view = selectedView.id;
                        patchToSave.view_name = selectedView.name;
                    }
                    onSave(__assign(__assign({}, patchToSave), position), newEdge);
                    break;
                case 'view':
                    patchToSave = {
                        name: option.label,
                        type: 'view',
                        view: option.value,
                        settings: {},
                    };
                    selectedView = views.find(function (item) { return item.id === option.value; });
                    if (selectedView && selectedView.type === 'view') {
                        patchToSave.type = selectedView.type;
                        patchToSave.view = selectedView.id;
                        patchToSave.view_name = selectedView.name;
                    }
                    onSave(__assign(__assign({}, patchToSave), position), newEdge);
                    break;
                case 'custom_logic':
                    patchToSave = {
                        name: option.label,
                        type: 'logic',
                        logic: 'custom_logic',
                        custom_logic: option === null || option === void 0 ? void 0 : option.groupId,
                    };
                    onSave(__assign(__assign({}, patchToSave), position), newEdge);
                    break;
                /**
                 * default is intended to check types of logic and navigation
                 * Also anything else (no additional types that the above in the most cases)
                 */
                default:
                    if (option.value === NAVIGATION_TYPES.SUB_MENU &&
                        option.value ===
                            ((_b = careerSource === null || careerSource === void 0 ? void 0 : careerSource.sourcePatch) === null || _b === void 0 ? void 0 : _b[PATCH_TYPES.NAVIGATION])) {
                        return;
                    }
                    patchToSave = (_a = {
                            name: option.label,
                            type: type
                        },
                        _a[type] = option.value,
                        _a.settings = __assign({}, ((option === null || option === void 0 ? void 0 : option.groupId) && { reference: option === null || option === void 0 ? void 0 : option.groupId })),
                        _a);
                    onSave(__assign(__assign({}, patchToSave), position), newEdge);
            }
        }
        handleOnCloseModal();
    }, [
        careerSource.position,
        careerSource === null || careerSource === void 0 ? void 0 : careerSource.sourceNode,
        careerSource === null || careerSource === void 0 ? void 0 : careerSource.sourcePatch,
        careerSource === null || careerSource === void 0 ? void 0 : careerSource.sourcePort,
        customLogics,
        handleOnCloseModal,
        onCreateNewCustomLogic,
        onCreateNewView,
        onSave,
        views,
    ]);
    /**
     * Submenu cannot be connected to another submenu
     */
    var checkShouldTileWidgetDisabled = useCallback(function (type) {
        var _a;
        return type === NAVIGATION_TYPES.SUB_MENU &&
            type === ((_a = careerSource === null || careerSource === void 0 ? void 0 : careerSource.sourcePatch) === null || _a === void 0 ? void 0 : _a[PATCH_TYPES.NAVIGATION]);
    }, [careerSource === null || careerSource === void 0 ? void 0 : careerSource.sourcePatch]);
    var renderOptions = useCallback(function (section, group) {
        switch (section.display) {
            case 'tile':
                return (_jsx(GridWidget, __assign({ colWidth: 80, colGap: 6, shrink: (section === null || section === void 0 ? void 0 : section.optionCount) === 0, spaced: group.type === 'navigation' }, { children: group.options.map(function (option) { return (_jsx(TileWidget, { disabled: checkShouldTileWidgetDisabled(option.value), option: option, onClick: checkShouldTileWidgetDisabled(option.value)
                            ? undefined
                            : function () { return onSubmit(group.type, option); } }, option.value)); }) }), group.label));
            case 'card':
                return (_jsx(GridWidget, __assign({ colWidth: 120, shrink: (section === null || section === void 0 ? void 0 : section.optionCount) === 0 }, { children: group.options.map(function (option) { return (_jsx(CardWidget, { option: option, onClick: function () { return onSubmit(group.type, option); } }, option.value)); }) }), group.label));
            default:
                return group.options.map(function (option) { return (_jsx(BlockWidget, { label: option.label, youTubeId: option === null || option === void 0 ? void 0 : option.youTubeId, title: option === null || option === void 0 ? void 0 : option.title, info: option === null || option === void 0 ? void 0 : option.info, link: option === null || option === void 0 ? void 0 : option.link, helpModalOpen: helpModalOpen, onClick: function () { return onSubmit(group.type, option); } }, option.value)); });
        }
    }, [checkShouldTileWidgetDisabled, helpModalOpen, onSubmit]);
    var renderGroup = useCallback(function (section) {
        if (searchValue || section.type === 'route') {
            return (_jsx(NonAccordionWrapper, { children: section.options.map(function (group) { return renderOptions(section, group); }) }));
        }
        return section.options.map(function (group) { return (_jsx(ModernAccordion, __assign({ title: group.label, icon: group.icon }, { children: renderOptions(section, group) }), group.label)); });
    }, [renderOptions, searchValue]);
    var renderSection = useCallback(function (section) {
        if (searchValue || (section === null || section === void 0 ? void 0 : section.noAccordion)) {
            return (_jsx(NonAccordionWrapper, { children: renderGroup(section) }));
        }
        return (_jsx(ModernAccordion, __assign({ title: section.label }, { children: _jsx(Wrapper, { children: renderGroup(section) }) }), section.label));
    }, [renderGroup, searchValue]);
    useEffect(function () {
        setPatchSchema(buildPatchSchema());
    }, [buildPatchSchema]);
    useEffect(function () {
        if (patchFilter === null || patchFilter === void 0 ? void 0 : patchFilter.length) {
            dispatchTabIndex(1);
        }
    }, [dispatchTabIndex, patchFilter === null || patchFilter === void 0 ? void 0 : patchFilter.length]);
    return (_jsx(Modal, __assign({ isOpen: isModalOpen, onRequestClose: handleOnCloseModal, contentLabel: "PatchNodes", style: customModalStyles((modalPosition === null || modalPosition === void 0 ? void 0 : modalPosition.x) - 75, (modalPosition === null || modalPosition === void 0 ? void 0 : modalPosition.y) - 25, isAddPatchModalFromFloatingMenu), shouldCloseOnEsc: true, shouldCloseOnOverlayClick: true }, { children: _jsxs(ModalContent, { children: [_jsxs(HeaderContainer, { children: [_jsx(Searchbar, { placeholder: "Search Patches", style: __assign({}, (!searchValue && { marginBottom: 16 })), onChange: handleOnSearchChange }), !searchValue && (_jsxs(TabContainer, { children: [!(patchFilter === null || patchFilter === void 0 ? void 0 : patchFilter.length) ? (_jsxs(Tab, __assign({ onClick: function () { return dispatchTabIndex(0); }, active: tabIndex === 0 }, { children: [_jsx(Icon, { iconSize: 14, icon: faLayerGroup }), _jsx(TabText, { children: "Views" })] }))) : (_jsx(_Fragment, {})), _jsxs(Tab, __assign({ onClick: function () { return dispatchTabIndex(1); }, active: tabIndex === 1 }, { children: [_jsx(Icon, { iconSize: 18, icon: faCodeBranch }), _jsx(TabText, { children: "Logic" })] })), _jsxs(Tab, __assign({ onClick: function () { return dispatchTabIndex(2); }, active: tabIndex === 2, borderless: true }, { children: [_jsx(Icon, { iconSize: 18, icon: faDiamondTurnRight }), _jsx(TabText, { children: "Navigation" })] }))] }))] }), _jsx(PatchContainer, __assign({ isOpen: isHelpModalOpen }, { children: (patchSchema === null || patchSchema === void 0 ? void 0 : patchSchema.length) ? (patchSchema.map(function (section) { return (_jsxs(Wrapper, { children: [searchValue && (section === null || section === void 0 ? void 0 : section.optionCount) ? (_jsx(SectionTitle, __assign({ shrink: (section === null || section === void 0 ? void 0 : section.optionCount) === 0 }, { children: "".concat(section.label, " (").concat(section.optionCount, ")") }))) : (_jsx(_Fragment, {})), renderSection(section)] }, section.label)); })) : (_jsx(_Fragment, {})) }))] }) })));
};
